
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventAlias]/news",
      function () {
        return require("private-next-pages/events/[eventAlias]/news/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventAlias]/news"])
      });
    }
  